import { useTranslate } from '@tolgee/react';

const useMixingTokoText = () => {
  const { t } = useTranslate();

  const orderReminderTitleI18n: string = 'marketing.催下单';
  const filterRulesI18n: string = 'marketing.如果命中设定的条件，将不会进行催下单';

  return {
    // 催下单title
    orderReminderTitle: {
      text: t(orderReminderTitleI18n),
      i18nKey: orderReminderTitleI18n,
    },
    // 过滤规则
    filterRules: {
      text: t(filterRulesI18n),
      i18nKey: filterRulesI18n,
    },
  };
};

export default useMixingTokoText;
